<div *ngIf="crearRegistro || editarRegistro" style="margin-bottom: 20px;">
    <button pButton type="button" icon="pi pi-times" class="p-button-rounded boton-rosado" style="float: right;" (click)="onCancelarEdicion()">
    </button>
</div>

<div *ngIf="crearRegistro || editarRegistro">
    <app-solicitud 
        [promocion]="promocionActual" 
        [idsolicitud]="idRegistro" 
        (RegistroGuardado)="onRegistroGuardado()">
    </app-solicitud>
</div>

<div class="form-resultados-container" *ngIf="columnas?.length && !editarRegistro && !crearRegistro">

  <div class="mb-2" style="display:flex; align-items:center; gap: 0.5rem;">
    <p-multiSelect
      [options]="opciones"
      [(ngModel)]="columnasSeleccionadas"
      optionLabel="label"
      selectedItemsLabel="{0} columnas seleccionadas"
      defaultLabel="Seleccionar columnas"
      (onChange)="filtrar()">
    </p-multiSelect>
    <button mat-raised-button (click)="filtrar()">Filtrar</button>
  </div>

  <p-table
    [value]="registros"
    [paginator]="true"
    [rows]="tampag"
    [showCurrentPageReport]="true"
    [resizableColumns]="true"
    [rowHover]="true"
    [rowsPerPageOptions]="[10,50,100,500]"
    responsiveLayout="scroll">

    <ng-template pTemplate="header">
      <tr>
        <th *ngFor="let columna of columnasSeleccionadas" style="text-transform: capitalize;">
          <span style="font-weight: bold;">{{ columna }}</span>
          <p-columnFilter
            type="text"
            [field]="columna"
            matchMode="contains"
            [showMenu]="false">
          </p-columnFilter>
        </th>
        <th>Opciones</th>
      </tr>
    </ng-template>

    <ng-template pTemplate="body" let-registro>
      <tr (click)="navigateToRegistro(registro._id)" pSelectableRow [style]="{'cursor': 'pointer'}">
        <td *ngFor="let columna of columnasSeleccionadas">{{ registro[columna] }}</td>
        <td>


          <button *ngIf="PermisoEditar" pButton pRipple type="button" icon="pi pi-pencil" 
                  class="p-button-rounded p-button-text p-button-warning"
                  title="Editar Registro"
                  (click)="navigateToEditarRegistro(registro._id); $event.stopPropagation()">
          </button>

          <button *ngIf="PermisoEliminar" pButton pRipple type="button" icon="pi pi-trash"
                  class="p-button-rounded p-button-text p-button-danger"
                  title="Eliminar Registro"
                  (click)="eliminarRegistro(registro._id); $event.stopPropagation()">
          </button>
        </td>
      </tr>
    </ng-template>

    <ng-template pTemplate="summary">
      <div class="p-d-flex p-ai-center p-jc-between">
        Total Registros : {{ registros ? registros.length : 0 }}
      </div>
    </ng-template>
  </p-table>
</div>

